import { atom } from "jotai";

import {
  VerificationModalStepStateAtom,
  defaultVerificationModalStepState,
} from "../../stores";

export const ProceedToInitialStepAtom = atom(null, (get, set) => {
  set(VerificationModalStepStateAtom, defaultVerificationModalStepState);
});
